import * as React from 'react';

export interface SidebarDividerProps {
  dataHook?: string;
  fullWidth?: boolean;
}

export default class SidebarDivider extends React.PureComponent<SidebarDividerProps> {}
